module.exports = __webpack_public_path__ + "img/tool_2.3d8a821e.png";